import { useDispatch } from "react-redux";
import { logout } from "../features/auth/authSlice";

export default function Header() {
  const dispatch = useDispatch();

  return (
    <div className="header">
      <div className="header-title">AI Health</div>

      <button className="logout-btn" onClick={() => dispatch(logout())}>
        Logout
      </button>
    </div>
  );
}
